export default {
  Active: 'success',
  Invited: 'dark',
}
